// remove after api integration
import i18n from 'src/i18n.js';

export const DropdownOption = () => ({
    template: [
        {
            id: '1',
            label: i18n.t('filter.productDetailsFilter.title4'),
            code: 'Description-asc',
        },
        {
            id: '2',
            label: i18n.t('filter.productDetailsFilter.title3'),
            code: 'Description-desc',
        },
        {
            id: '3',
            label: i18n.t('filter.productDetailsFilter.title2'),
            code: 'ProductCode-asc',
        },
        {
            id: '4',
            label: i18n.t('filter.productDetailsFilter.title1'),
            code: 'ProductCode-desc',
        },
    ],
});
export const Alphabets = () => [
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.A'),
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.B'),
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.C'),
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.D'),
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.E'),
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.F'),
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.G'),
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.H'),
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.I'),
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.J'),
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.K'),
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.L'),
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.M'),
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.N'),
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.O'),
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.P'),
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.Q'),
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.R'),
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.S'),
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.T'),
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.U'),
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.V'),
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.W'),
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.X'),
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.Y'),
    i18n.t('scheduleSurgery.productGuide.alphabetLetter.Z'),
];
